var $class="se2--utilities",$name="utilities",$path="app/components/utilities/validateCheckboxes.js",$this={$class,$name,$path,};import some from 'lodash/some';

const validateCheckboxes = (checkboxContainerElement) => some(
  checkboxContainerElement.querySelectorAll('input'),
  ({ checked }) => checked,
);

export default validateCheckboxes;
